import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Table,
  Button,
  Card,
  CardTitle,
  Badge,
  FormGroup,
  Input,
  Col,
  Row,
  UncontrolledTooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Pagination from '../../common/Pagination';
import { debounce } from 'underscore';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Swal from 'sweetalert2';
import {
  AGENCY_SERVICEREQUEST_LIST_URL,
  AGENCYLIST_URL,
  AGENCY_DOCUMENT_DELETE_URL,
  USER_DELETE_AGENCY_LIST,
} from '../../../utils/APIEndpoints';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import {
  getAlertToast,
  dateTimeFormat,
  amountFormat,
  getConfirm,
} from '../../../utils/functions/CustomFunctions';
import CustomTableLoader from '../../common/CustomTableLoader';
import CustomTableEmptyRecord from '../../common/CustomTableEmptyRecord';
import CustomViewButton from '../../common/CustomViewButton';
import View from '../../requests/view';
import { Link } from 'react-router-dom';
import { ADMIN_AGENCYDETAILS_PATH } from '../../../utils/AppRoutes';
import PaymentDetails from './paymentDetails';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { CSVLink } from 'react-csv';
import CustomDeleteButton from '../../common/CustomDeleteButton';
import Checkbox from '../../common/CustomCheckbox';
import * as Icon from 'react-icons/fi';

const paymentStatusColor = {
  Success: 'primary',
  Failed: 'danger',
  Pending: 'warning',
};

//Table Columns
const tableColumns = [
  { title: 'Payment Date' },
  { title: 'Order ID' },
  { title: 'Customer Name' },
  { title: 'Agency' },
  { title: 'Document Name' },
  { title: 'Total Fee' },
  { title: 'Invoice' },
  { title: 'Document Type' },
  { title: 'Payment Status' },
  { title: 'Completed Form' },
  { title: 'Actions' },
];
const headers = [
  { label: 'Payment Date', key: 'paymentDate' },
  { label: 'Order ID', key: 'orderId' },
  { label: 'Customer Name', key: 'name' },
  { label: 'Agency', key: 'agancyName' },
  { label: 'Document Name', key: 'serviceName' },
  { label: 'Total Fee', key: 'amount' },
  { label: 'Invoice', key: 'invoiceId' },
  { label: 'Document Type', key: 'documentType' },
  { label: 'Payment Type', key: 'paymentType' },
  { label: 'Payment Status', key: 'paymentStatus' },
  { label: 'Completed Form', key: 'documentUrl' },
];

function AdminServiceRequests(props) {
  //State
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const [additionalDocuments, setAdditionalDocuments] = useState({});
  const [feeDetails, setFeeDetails] = useState({});
  const [agenciesList, setAgenciesList] = useState([]);
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [selected, setSelected] = useState([]);
let additionalTotal=0
  const viewToggle = () => setViewModal(!viewModal);
  const paymentDetailsToggle = () =>
    setPaymentDetailsModal(!paymentDetailsModal);
  const [filter, setFilter] = useState({
    invoiceId: '',
    serviceName: '',
    status: '',
    paymentStartDate: '',
    paymentEndDate: '',
    paymentStatus: '',
    agencyId: '',
    count: 10,
  });
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          offset: currentPage,
        }),
      500
    )
  ).current;

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleReset = () => {
    setStartDate('');
    setEndDate('');
    setFilter((val) => ({
      ...val,
      invoiceId: '',
      serviceName: '',
      status: '',
      paymentStartDate: '',
      paymentEndDate: '',
      paymentStatus: '',
      agencyId: '',
    }));
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
    });
  };

  const startDateChange = (date) => {
    setStartDate(date || '');
    let paymentStartDate = date ? moment(date).format('MM/DD/YYYY') : '';
    setFilter({ ...filter, ['paymentStartDate']: paymentStartDate });
  };

  const endDateChange = (date) => {
    setEndDate(date || '');
    let paymentEndDate = date ? moment(date).format('MM/DD/YYYY') : '';
    setFilter({ ...filter, ['paymentEndDate']: paymentEndDate });
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    setLoading(true);
    const options = {
      method: 'GET',
      url: AGENCY_SERVICEREQUEST_LIST_URL,
      headers: authHeader(),
      params: { ...queryParams, isDeleted: false },
    };
    try {
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === 'Success') {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {

          let { paymentDate, amount, firstName, lastName } = record;
          let formattedData = {
            paymentDate: paymentDate
              ? dateTimeFormat(paymentDate, 'MM/DD/YYYY hh:mm A')
              : '',
            amount: amountFormat(amount),
            name: firstName + ' ' + lastName,
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRowPerPage = ({ target: { value, name } }) => {
    setCurrentPage(0);
    setFilter((va) => ({ ...va, [name]: value || undefined }));
  };
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };

  //Get Agencies List
  const getAgenciesList = async () => {
    try {
      const options = {
        method: 'GET',
        url: AGENCYLIST_URL,
        headers: authHeader(),
        // params : queryParams
      };
      const response = await API(options);
      const { status, data: initialResponse = [] } = response.data;
      if (status === 'Success') {
        if (initialResponse && initialResponse.length) {
          const agenciesList = Array.from(
            new Set(initialResponse.map((record) => record.agencyId))
          ).map((id) => {
            return {
              agencyId: id,
              agencyName: initialResponse.find(
                (data) => parseInt(data.agencyId) === parseInt(id)
              ).companyName,
            };
          });
          setAgenciesList(agenciesList);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
    }
  };
  const removeRecord = (event) => {
    const agencyServiceId = event.currentTarget.dataset.agency_service_id;
    Swal.fire(
      getConfirm('warning', 'Are you sure you want to remove this document?')
    ).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const options = {
            method: 'DELETE',
            url: AGENCY_DOCUMENT_DELETE_URL,
            headers: authHeader(),
            // params: { agencyId: 0, agencyServiceId },
            params: { agencyServiceId },
          };
          const response = await API(options);
          const { status } = response.data;
          if (status === 'Success') {
            getGridData({
              ...filter,
              // count: rowsPerPage || undefined,
              offset: currentPage,
              // agencyId: parseInt(agencyId),
              isDeleted: false,
            });
            Swal.fire(getAlertToast('success', 'Record removed successfully'));
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast('error', data.message));
          }
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const onChangeChecked = (e) => {
    if (e === true) {
      setSelected(
        gridData
          .map((record) => record.agencyServiceId)
          .filter((agencyServiceId) => agencyServiceId !== undefined && agencyServiceId !== null)
      );
    } else {
      setSelected([]);
    }
  };

  const viewAdditionalDocuments = async (documents, e) => {
    setAdditionalDocuments(JSON.parse(documents));
    setViewModal(true);
  };

  const viewFeeDetails = async (
    documentFee,
    additionalFee,
    totalFee,
    convenienceFee,
    e
  ) => {
    setFeeDetails({
      documentFee: documentFee,
      additionalFee: JSON.parse(additionalFee),
      totalFee: totalFee,
      convenienceFee: convenienceFee,
    });
   
    setPaymentDetailsModal(true);
  };
  console.log(additionalTotal)
  const checkvalues = (e, agencyServiceId) => {
    if (e === true) {
      setSelected((prevSelected) =>
        prevSelected.includes(agencyServiceId)
          ? prevSelected
          : [...prevSelected, agencyServiceId]
      );
    } else {
      setSelected((prevSelected) =>
        prevSelected.filter((id) => id !== agencyServiceId)
      );
    }
  };

  //Did Mount
  useEffect(() => {
    getAgenciesList();
  }, []);

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const {
    invoiceId = '',
    serviceName = '',
    status = '',
    paymentDate = '',
    paymentStatus = '',
    agencyId,
  } = filter;
  const allSelected =
    gridData.length > 0 &&
    gridData.every((record) => selected.includes(record.agencyServiceId));

  //delete Multiple record
  const deleteRecord = async () => {
    Swal.fire(
      getConfirm(
        'warning',
        'Documents and Users will be deleted  regarding to this agency Are you sure you want to continue?'
      )
    ).then((result) => {
      if (result.isConfirmed) {
        deleteAdmin();
      }
    });
  };

  const deleteAdmin = async (event, agencyServiceId) => {
    // const agencyServiceId = event.currentTarget.dataset.agency_service_id;
    let values = [];
    selected.forEach((value) => {
      values.push({
        // agencyId: 0,
        agencyServiceId: value,
      });
    });
    console.log(values);
    try {
      setLoading(true);
      const option = {
        method: 'DELETE',
        url: USER_DELETE_AGENCY_LIST,
        headers: authHeader(),
        data: { agencyId: 0, agencyList: values },
      };
      const response = await API(option);
      const { status } = response.data;
      if (status == 'Success') {
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
          isDeleted: false,
        });
      }

      console.log(selected);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <Card body className="mt-5">
        <div>
          <CardTitle className="mb-4 f-l w-fit">Service Requests </CardTitle>

          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "10px 7px 3px 16px",
              fontSize: "19px",
              padding: "3px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
          {selected.length > 0 ? (
            <CustomDeleteButton
              style={{ marginLeft: "620px", marginTop: "5px" }}
              // data-agency_service_id={agencyServiceId}
              onClick={deleteRecord}
            />
          ) : (
            ""
          )}
          <div className="top-btn" style={{ float: "right" }}>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" className="f-r" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <CSVLink
                   className='link'
                    key={`csv_${gridData.length}`}
                    data={gridData}
                    headers={headers}
                    filename={"Service_report.csv"}
                    target="_blank"
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        {isFilterOpen && (
          <Row form className="mb-4" style={{ marginTop: "1rem" }}>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="serviceName"
                  placeholder="Document Name"
                  onChange={changeFilterField}
                  value={serviceName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="invoiceId"
                  placeholder="Invoice"
                  onChange={changeFilterField}
                  value={invoiceId}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <DatePicker
                  style={{ zIndex: "9999 !important", width: "100%" }}
                  selected={startDate}
                  onChange={startDateChange}
                  dateFormat="MM/dd/yyy"
                  maxDate={endDate}
                  placeholderText="Start Date"
                  className="form-control mb-3"
                  width="100%"
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: {
                      behavior: ["bottom"],
                    },
                    preventOverflow: {
                      enabled: false,
                    },
                    hide: {
                      enabled: false,
                    },
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <DatePicker
                  style={{ zIndex: "9999 !important", width: "100%" }}
                  selected={endDate}
                  onChange={endDateChange}
                  dateFormat="MM/dd/yyy"
                  placeholderText="End Date"
                  className="form-control mb-2"
                  minDate={startDate}
                  // width='100%'
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: {
                      behavior: ["bottom"],
                    },
                    preventOverflow: {
                      enabled: false,
                    },
                    hide: {
                      enabled: false,
                    },
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={1} />
            <Col md={3}>
              <FormGroup>
                <Input
                  type="select"
                  name="agencyId"
                  placeholder="Agency"
                  onChange={changeFilterField}
                  value={agencyId}
                >
                  <option value={""}>-- Show All Agencies --</option>
                  {agenciesList.map((record, index) => (
                    <option
                      value={record.agencyServiceId}
                      key={`agency_list_${index}`}
                    >
                      {record.agencyName}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="select"
                  name="paymentStatus"
                  placeholder="Status"
                  onChange={changeFilterField}
                  value={paymentStatus}
                >
                  <option value={""}>-- Show All Status --</option>
                  <option value={"Pending"}>Pending</option>
                  <option value={"Success"}>Success</option>
                  <option value={"Failed"}>Failed</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          {/* Table Header */}
          {/* <CustomTableHeader tableColumns={tableColumns} /> */}
          <thead style={{ backgroundColor: "#eee" }}>
            <tr>
              <th>
                {
                  <Checkbox
                    icon={<Icon.FiCheck color="#174A41" size={14} />}
                    borderColor="#D7C629"
                    checked={allSelected}
                    onChange={onChangeChecked}
                    style={{ cursor: "pointer" }}
                  />
                }
              </th>

              {tableColumns.map(({ title }, key) => (
                <th key={`head_list_${key}`}>{title}</th>
              ))}
            </tr>
          </thead>
          {/* Table Header */}
          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => (
                      <tr key={`record_key_${key}`}>
                        <td>
                          {
                            <Checkbox
                              icon={<Icon.FiCheck color="#174A41" size={14} />}
                              borderColor="#D7C629"
                              style={{ cursor: "pointer" }}
                              //checked={active}
                              checked={selected.includes(record.agencyServiceId)}
                              onChange={(e) =>
                                checkvalues(e, record.agencyServiceId)
                              }
                            />
                          }
                        </td>
                        <td style={{ width: "100px" }}>{record.paymentDate}</td>
                        <td>{record.orderId}</td>
                        <td>
                          {record.firstName} {record.lastName}
                        </td>
                        <td>
                          <Link
                          className='link'
                            to={`${ADMIN_AGENCYDETAILS_PATH}/${record.agencyId}`}
                          >
                            {record.agancyName}
                          </Link>
                        </td>
                        <td>{record.serviceName}</td>
                        <td>
                          {/* <Link
                            onClick={(e) =>
                              viewFeeDetails(
                                record.serviceAmount,
                                record.extraFeeList,
                                record.amount,
                                e
                              )
                            }
                          >
                            {record.amount}
                          </Link> */}

                          <div
                            style={{ color: "#007bff", cursor: "pointer" }}
                            onClick={(e) =>
                              viewFeeDetails(
                                record.serviceAmount,
                                record.extraFeeList,
                                record.amount,
                                record.serviceFeeAmount,
                                e
                              )
                            }
                          >
                            {/* {record.amount} */}$
                            {(
                              (parseFloat(
                                String(record.serviceAmount).replace("$", "")
                              ) || 0) +
                              (parseFloat(
                                String(record.serviceFeeAmount).replace("$", "")
                              ) || 0) +
                              (record.extraFeeList
                                ? JSON.parse(record.extraFeeList).reduce(
                                    (acc, fee) =>
                                      acc + parseFloat(fee.totalAmount || 0),
                                    0
                                  )
                                : 0)
                            ).toFixed(2)}
                          </div>
                        </td>
                        <td>#{record.invoiceId}‎</td>
                        <td>{record.paymentType}</td>
                        <td>
                          <Badge
                            color={paymentStatusColor[record.paymentStatus]}
                          >
                            {record.paymentStatus}
                          </Badge>
                          {record.paymentStatus == "Failed" && (
                            <>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                  "margin-left": "5px",
                                }}
                                href="#"
                                id={`UncontrolledTooltipExample_${key}`}
                              >
                                <BsFillInfoCircleFill />
                              </span>

                              <UncontrolledTooltip
                                placement="top"
                                target={`UncontrolledTooltipExample_${key}`}
                              >
                                {record.responseText}
                              </UncontrolledTooltip>
                            </>
                          )}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {record.documentUrl ? (
                            <Button
                              tag="a"
                              href={record.documentUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="action-btn"
                              color="success"
                              type="button"
                            >
                              <span className="fas fa-download"></span>
                            </Button>
                          ) : (
                            ""
                          )}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {/* Custom View Button  */}
                          {record.additionalDocuments ? (
                            <CustomViewButton
                              keyvalue={key}
                              onClick={(e) =>
                                viewAdditionalDocuments(
                                  record.additionalDocuments,
                                  e
                                )
                              }
                            />
                          ) : (
                            ""
                          )}
                          {/* Custom View Button  */}
                          <CustomDeleteButton
                            keyvalue={key}
                            data-agency_service_id={record.agencyServiceId}
                            onClick={removeRecord}
                          />
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
          {/* Table Body */}
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={handleRowPerPage}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>
      {/* View Dialog */}
      {viewModal && (
        <View
          data={additionalDocuments}
          viewToggle={viewToggle}
          viewModal={viewModal}
        />
      )}
      {/* View Dialog */}
      {/* Payment Details Dialog */}
      {paymentDetailsModal && (
        <PaymentDetails
          feeDetails={feeDetails}
          paymentDetailsToggle={paymentDetailsToggle}
          paymentDetailsModal={paymentDetailsModal}
        />
      )}
      {/* Payment Details Dialog */}
    </Fragment>
  );
}

export default AdminServiceRequests;
